import Transaction from '@/models/storePanel/Transaction';
import moment from 'moment';

import axios from 'axios';
import _ from 'lodash';
// const puppeteer = require('puppeteer');
let browser;

const getDefaultState = () => ({
  mobileLoading: false,
  refundLoading: false,
  productsLoading: false,
  previewLoading: false,
  lastZLoading: false,
  products: [],
  selectedProducts: [],
  transactionStatuses: [],
  transactionTypes: [],
  transactionProfile: {},
  transactions: [],
  transaction: new Transaction(),
  transactionPreview: { products: [] },
  generalCouponClaims: [],
  samplingCoupons: [],
  coupons: [],
  last24Revenue: [],
  lastZUrl: null,
  transaction_identifier: null,
  smsVerificatonDialog: false,
  confirmationToken: '',
  cancelDialog: false,
  superUserConfirmationDialog: false,
  couponVerification: false,
  productsPagination: {},
  customerData: {},
  attributes: [],
  ordersAllowed: false,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setMobileLoading(state, payload) {
      state.mobileLoading = payload;
    },

    setRefundLoading(state, payload) {
      state.refundLoading = payload;
    },

    setProductsLoading(state, payload) {
      state.productsLoading = payload;
    },

    setPreviewLoading(state, payload) {
      state.previewLoading = payload;
    },

    setProducts(state, payload) {
      state.products = payload.map((p) => {
        if (state.selectedProducts.length) {
          let selectedProduct = state.selectedProducts.find((s) => s.product_id === p.product_id);
          if (selectedProduct) p.selected = true;
        } else {
          p.selected = false;
        }

        return p;
      });
    },

    setProductsPagination(state, payload) {
      state.productsPagination = payload;
    },

    setCouponVerification(state, payload) {
      state.couponVerification = payload;
    },
    setSelectedProducts(state, payload) {
      state.selectedProducts = payload;
    },
    setCustomerData(state, payload) {
      state.customerData = payload || {};
    },

    setTransactionStatuses(state, payload) {
      state.transactionStatuses = payload.map((s) => {
        s.selected = false;
        return s;
      });
    },

    setTransactionTypes(state, payload) {
      state.transactionTypes = payload.map((t) => {
        t.selected = false;
        return t;
      });
    },

    setItems(state, payload) {
      state.transactions = payload.map((t) => {
        t.loading = false;
        t.created_at = moment(t.created_at).format('DD/MM/YYYY HH:mm');
        return t;
      });
    },

    setTransactionProfile(state, payload) {
      payload.created_at = moment(payload.created_at).format('DD/MM/YYYY HH:mm');
      payload.transaction_items.forEach((t) => {
        t.total_row_price = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
        }).format(t.total_row_price);

        if (t.reward_type_id === 4) t.quantity = '';
      });
      state.transactionProfile = payload;
    },

    setItem(state, payload) {
      state.transaction = new Transaction(payload);
    },

    setTransactionPreview(state, payload) {
      state.transactionPreview = payload;
    },

    setLast24Revenue(state, payload) {
      state.last24Revenue = payload;
    },

    setLastZUrl(state, payload) {
      state.lastZUrl = payload;
    },

    setLastZLoading(state, payload) {
      state.lastZLoading = payload;
    },

    setTransactionProductCouponClaims(state, payload) {
      payload.forEach((payloadProduct) => {
        let product = state.transaction.products.find(
          (p) => p.product_id === payloadProduct.product_id
        );

        if (product) {
          product.product_coupons = payloadProduct.product_coupons.map((p) => {
            p.text = {};
            p.text.el = `${p.product_free.name.el} (${p.code})`;
            p.text.en = `${p.product_free.name.en} (${p.code})`;
            p.text.it = `${p.product_free.name.it} (${p.code})`;
            return p;
          });

          let index = state.transaction.products.findIndex(
            (p) => p.product_id === payloadProduct.product_id
          );

          state.transaction.products.splice(index, 1, product);
        }
      });
    },

    setGeneralCouponClaims(state, payload) {
      state.generalCouponClaims = payload.map((g) => {
        let coupon = state.transaction.general_coupon_claims_for_use.find(
          (c) => c.coupon_id === g.coupon_id
        );

        if (coupon) g.selected = coupon.selected;
        else g.selected = false;

        return g;
      });
    },

    setSamplingCoupons(state, payload) {
      state.samplingCoupons = payload.map((s) => {
        let coupon = state.transaction.sampling_coupons_for_use.find(
          (c) => c.coupon_id === s.coupon_id
        );

        if (coupon) s.selected = coupon.selected;
        else s.selected = false;

        return s;
      });
    },

    removeItem(state, id) {
      state.transactions = state.transactions.filter((p) => p.product_id !== id);
    },

    setCoupons(state, payload) {
      state.coupons = payload;
    },

    setTransactionIdentifier(state, payload) {
      state.transaction_identifier = payload;
    },

    setSmsVerificatonDialog(state, payload) {
      state.smsVerificatonDialog = payload;
    },

    setConfirmationToken(state, payload) {
      state.confirmationToken = payload;
    },

    setCancelDialog(state, payload) {
      state.cancelDialog = payload;
    },

    setSuperUserConfirmationDialog(state, payload) {
      state.superUserConfirmationDialog = payload;
    },
    setAttributes(state, payload) {
      state.attributes = payload;
    },
    setOrdersAllowed(state, payload) {
      state.ordersAllowed = payload;
    },
  },

  actions: {
    async getProducts({ commit, state }, { query, page }) {
      try {
        commit('setProductsLoading', true);
        const { data } = await Transaction.getProducts(query);
        let products = data.data.products;
        for (let selectedProduct of state.selectedProducts) {
          let foundProduct = products.find((x) => {
            return x.product_id === selectedProduct.product_id;
          });
          if (foundProduct) {
            foundProduct.selected = true;
          }
        }
        if (page > 1) {
          commit('setProducts', [...state.products, ...products]);
        } else {
          commit('setProducts', products);
        }
        commit('setProductsPagination', data.data.pagination);

        commit('setProductsLoading', false);
      } catch (ex) {
        commit('setProductsLoading', false);
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getProductFromSku({ commit, state }, sku) {
      try {
        commit('setProductsLoading', true);
        const { data } = await Transaction.getProducts('?sku=' + sku);
        let product = null;
        if (data.data.products.length) {
          product = data.data.products[0];
          product.selected = true;
          commit('setProducts', [...state.products, product]);
        }
        commit('setProductsLoading', false);
        return product;
      } catch (ex) {
        commit('setProductsLoading', false);
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async clearLastZUrl({ commit }, linkToXLS) {
      window.open(linkToXLS);
      commit('setLastZUrl', null);
    },

    async getLastZ({ commit }, fileType) {
      try {
        commit('setLastZLoading', true);
        const res = await Transaction.getLastZDownload(fileType, { responseType: 'blob' });
        commit('setLastZLoading', false);
        return res;
      } catch (ex) {
        commit('setLastZLoading', false);
        console.error(ex?.response?.data?.message || ex);
        return ex?.response || ex;
      }
    },

    async getLast24Revenue({ commit }) {
      try {
        const { data } = await Transaction.getLast24Revenue();

        commit('setLast24Revenue', data.data.last_24h_transactions);
      } catch (ex) {
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getTransactionPreview({ commit, state, rootState }, showProducts) {
      try {
        commit('setPreviewLoading', true);

        let transaction = { ...state.transaction };
        Transaction.clearFalsyValues(transaction);

        const { data } = await Transaction.getTransactionPreview(transaction);

        if (showProducts) {
          commit('setTransactionProductCouponClaims', data.data.products);
        }

        if (data.data.general_coupon_claims) {
          if (data.data.general_coupon_claims.length) {
            commit('setGeneralCouponClaims', data.data.general_coupon_claims);
          }
        }

        commit('setSamplingCoupons', data.data.sampling_coupons);
        commit('setCoupons', data.data.coupons);

        // if (_.isEmpty(state.customerData)) {
        if (data.data.user_account_id || state.transactionPreview?.user_account_id) {
          let customerData = data.data.company_information || {};
          commit('setCustomerData', customerData);
        }

        state.customerData.mobile = state.customerData.mobile || transaction.user;
        state.customerData.country_id = rootState.storePanel.store.country.country_id;

        commit('setTransactionPreview', data.data);
        commit('setPreviewLoading', false);
      } catch (ex) {
        commit('setPreviewLoading', false);
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async claimCoupon({ commit, state, dispatch }, code) {
      try {
        commit('setPreviewLoading', true);
        await Transaction.claimCoupon({
          code: code,
          user: state.transaction.user,
        });

        dispatch('getTransactionPreview', false);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'Coupon claimed successfully for the user',
          },

          { root: true }
        );

        commit('setPreviewLoading', false);
      } catch (ex) {
        commit('setPreviewLoading', false);
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getTransactionStatuses({ commit }) {
      try {
        const { data } = await Transaction.getTransactionStatuses();

        commit('setTransactionStatuses', data.data);
      } catch (ex) {
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getTransactionTypes({ commit }) {
      try {
        const { data } = await Transaction.getTransactionTypes();

        commit('setTransactionTypes', data.data);
      } catch (ex) {
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getItems({ commit, dispatch }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Transaction.get(query);

        const { transactions, pagination } = data.data;

        commit('setItems', transactions);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getItem({ commit }, id) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Transaction.getItem(id);

        commit('setTransactionProfile', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async create({ commit, state, rootState }, uuid) {
      try {
        if (rootState.loading) {
          return null;
        }
        commit('setLoading', true, { root: true });
        let transaction = { ...state.transaction };

        Transaction.clearFalsyValues(transaction);
        if (transaction.products) {
          transaction.products.forEach((p) => {
            if (p.product_coupons_for_use && !p.product_coupons_for_use.length)
              delete p.product_coupons_for_use;
          });
        }
        transaction.receipt_validation_needed =
          !!transaction.receipt_number || !!transaction.receipt_identifier;
        const { data } = await Transaction.create(transaction, uuid);

        if (data.data.new_customer) {
          commit('setTransactionIdentifier', data.data.transaction_identifier);
          commit('setSmsVerificatonDialog', true);
        } else {
          commit('setItem', {});
          commit('setTransactionPreview', { products: [] });
          commit('setSelectedProducts', []);
          commit('setProducts', state.products);
          commit('setGeneralCouponClaims', []);
          commit('setSamplingCoupons', []);
          commit('setCoupons', []);
          commit('setResetValidation', true, { root: true });
          commit('setLoading', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully created transaction!',
            },

            { root: true }
          );
        }
      } catch (ex) {
        if (ex.response) {
          commit('setLoading', false, { root: true });
          commit('setErrorMessage', ex.response.data.message, {
            root: true,
          });
          setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        }
      }
    },

    async changeStatus({ commit, dispatch }, transaction) {
      try {
        transaction.loading = true;

        await Transaction.changeStatus(transaction);

        transaction.loading = false;
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated transaction!',
          },

          { root: true }
        );
        dispatch('storePanel/getPandingPayments', null, { root: true });
      } catch (ex) {
        transaction.loading = false;
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
      }
    },

    async updateMobilePayments({ commit }, item) {
      try {
        commit('setMobileLoading', true);

        await Transaction.updateMobilePayments(item);

        commit('storePanel/setMobilePayments', item.online_payment_processing, {
          root: true,
        });
        commit('setMobileLoading', false);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated mobile payments!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setMobileLoading', false);
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
      }
    },

    async refundTransaction({ commit, dispatch }, { item, query }) {
      try {
        commit('setRefundLoading', true);

        let transaction = { transaction_id: null, products: [] };
        transaction.transaction_id = item.transaction_id;
        item.products.forEach((p) => transaction.products.push({ ...p }));

        transaction.products.forEach((p) => {
          delete p.max_quantity;
          delete p.max_retail_price;
          delete p.name;
          delete p.reward_type_id;
          delete p.product_coupons_for_use;
        });

        await Transaction.refundTransaction(transaction);
        await dispatch('getItems', query);

        commit('setRefundLoading', false);
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully refunded transaction!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setRefundLoading', false);
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async cancelTransaction({ commit, dispatch }, { id, token, query }) {
      try {
        commit('setRefundLoading', true);
        const body = {
          transaction_id: id,
        };
        if (token) {
          body.confirmation_token = token;
        }

        const { data } = await Transaction.cancelTransaction(body);

        commit('setCancelDialog', false);
        commit('setRefundLoading', false);

        if (data.data.confirmation_token) {
          commit('setConfirmationToken', data.data.confirmation_token);
          commit('setSuperUserConfirmationDialog', true);
        } else {
          await dispatch('getItems', query);
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully canceled the transaction!',
            },

            { root: true }
          );
          commit('setSuperUserConfirmationDialog', false);
        }
      } catch (ex) {
        commit('setRefundLoading', false);
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async sendVerificationCode({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });
        const payload = {
          sms_verification_code: body.verificationCode,
          transaction_identifier: state.transaction_identifier,
        };

        await Transaction.sendVerificationCode(payload, body.uuid);

        commit('setItem', {});
        commit('setTransactionPreview', { products: [] });
        commit('setSelectedProducts', []);
        commit('setProducts', state.products);
        commit('setGeneralCouponClaims', []);
        commit('setSamplingCoupons', []);
        commit('setCoupons', []);
        commit('setResetValidation', true, { root: true });
        commit('setLoading', false, { root: true });
        commit('setSmsVerificatonDialog', false);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully created transaction!',
          },

          { root: true }
        );

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
      }
    },

    async fetchReceiptData({ commit }, url) {
      try {
        let receiptData = {};
        commit('setLoading', true, { root: true });
        if (url?.length > 5) {
          if (url.indexOf('ww1.aade.gr') >= 0 || url.indexOf('ww1.aade.gr') >= 0) {
            let data = await fetch(`https://api.allorigins.win/get?url=${encodeURIComponent(url)}`);
            let jsonData = await data.json();
            let receiptElement = jsonData.contents.split('<p class="receipt">')[1];
            let aaData = receiptElement.split('αύξοντα αριθμό (α/α) <strong>')[1];
            receiptData.receipt_number = aaData.split('</strong>')[0];
            let amountData = receiptElement.split('ποσού <strong>')[1];
            receiptData.amount = amountData.split(' ευρώ</strong>')[0];
            let fhmData = receiptElement.split('μηχανή (ΦΗΜ) με κωδικό  <strong>')[1];
            receiptData.cash_register_code = fhmData.split('</strong>')[0];
          } else if (url.indexOf('epsilonnet.gr') >= 0) {
            let urlParts = url.split('/');
            let documentId = urlParts?.length ? urlParts[urlParts.length - 1] : '';
            let xmlUrl = `https://epsilondigital-elinoil.epsilonnet.gr/filedocument/getfile?fileType=4&documentId=${documentId}`;
            let data = await axios.get(xmlUrl, {
              Accept: 'application/xml',
            });
            let parseString = require('xml2js').parseStringPromise;
            let jsonData = await parseString(data.data);
            let receiptElement = jsonData;
            receiptData.receipt_number =
              receiptElement.Invoice['cac:AdditionalDocumentReference'][0]['cbc:ID'][0];
            receiptData.amount =
              receiptElement.Invoice['cac:LegalMonetaryTotal'][0]['cbc:PayableAmount'][0]._;
            receiptData.cash_register_code =
              receiptElement.Invoice['cac:AccountingSupplierParty'][0]['cac:Party'][0][
                'cac:PartyTaxScheme'
              ][0]['cbc:CompanyID'][0];
          }
        } else {
          //invalid QR code, please scan a receipt
          receiptData.error = {
            el: 'Μη έγκυρο QR, παρακαλώ σαρώστε τον κωδικό QR της απόδειξης.',
            en: "Invalid QR, please scan a receipt's QR code.",
            it: 'QR non valido, scansionare il codice QR di una ricevuta.',
          };
        }

        commit('setLoading', false, { root: true });
        return receiptData;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex);
      }
    },

    async validateReceipt({ commit, state }, receiptData) {
      try {
        let validationRes = {};
        let validationData = {};
        commit('setLoading', true, { root: true });

        if (receiptData.cash_register_code && receiptData.receipt_number) {
          let validationRes = await Transaction.validateReceiptNumber({
            cash_register_code: receiptData.cash_register_code,
            receipt_number: receiptData.receipt_number,
          });
          validationData = validationRes.data;
        } else if (receiptData.receipt_identifier) {
          validationRes = await Transaction.validateReceiptIdentifier({
            receipt_identifier: receiptData.receipt_identifier,
          });
          validationData = validationRes.data;
        } else {
          //invalid QR code, please scan a receipt
          validationData.error = {
            el: 'Μη έγκυρα δεδομένα, παρακαλώ σαρώστε τον κωδικό QR της απόδειξης ή πληκτρολογίστε τον μοναδικό κωδικό της.',
            en: "Invalid QR, please scan a receipt's QR code, or type the receipt identifier.",
            it: "QR non valido, scansionare il codice QR di una ricevuta o digitare l'identificativo della ricevuta.",
          };
        }
        commit('setLoading', false, { root: true });
        return validationData;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex);
        return ex.response.data;
      }
    },

    async getCouponVerificationCode({ commit }, reqData) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Transaction.getCouponVerificationCode(reqData);

        commit('setLoading', false, { root: true });
        return data.code === 200;
      } catch (ex) {
        commit('setCouponVerificationCode', null);
        commit('setLoading', false, { root: true });

        console.error(ex?.response?.data?.message || ex);
        return false;
      }
    },

    async confirmCouponVerificationCode({ commit }, reqData) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Transaction.confirmCouponVerificationCode(reqData);
        commit('setCouponVerification', data.code === 200);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setCouponVerification', false);
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async updateCustomer({ commit }, { userAccountId, customerData }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Transaction.updateCustomer(userAccountId, customerData);

        // commit("setCustomerData", data.data?.company_information||{});
        commit('setLoading', false, { root: true });
        commit('setCustomerData', customerData);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'Customer details updated Successfully!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async getCustomerDetails({ commit }, { id, mobile }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Transaction.getCustomerDetails(id);

        let customerData = data.data.company_information || {};
        if (mobile.length > 8 && /^\d+$/.test(mobile)) {
          customerData.mobile = customerData.mobile || mobile;
        }

        commit('setCustomerData', customerData);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data?.message || ex);
      }
    },

    async getAttributes({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        let { data } = await Transaction.getAttributes();
        commit('setAttributes', data.data);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setCompanyStoresLoading', false);
      }
    },

    async updateOrdersAllowed({ commit }, orders_allowed) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Transaction.updateOrdersAllowed({ orders_allowed });
        if (data.code == 200) {
          commit('setOrdersAllowed', orders_allowed);
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'Orders settings updated successfully!',
            },
            { root: true }
          );
        }
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex?.response?.data?.message || 'Error', {
          root: true,
        });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex?.response?.data?.message || 'Error',
          },
          { root: true }
        );
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
